import { Icon } from "../ui";

// Bewusster Leerzustand für Routen, deren Feature §13-deferred ist (Explore/Canvas).
// Die Struktur/Route ist real; der Inhalt folgt — kein Mock, sondern ein definierter
// „kommt noch"-Zustand.
export function Placeholder({ icon, title, note }: { icon: string; title: string; note: string }) {
  return (
    <div className="grid h-full place-items-center p-8">
      <div className="max-w-sm text-center">
        <span className="mx-auto mb-4 grid h-14 w-14 place-items-center rounded-xl2 border border-border bg-surface-2 text-muted">
          <Icon name={icon} size={26} />
        </span>
        <h2 className="text-lg font-semibold">{title}</h2>
        <p className="mt-1 text-sm text-muted">{note}</p>
      </div>
    </div>
  );
}
